import * as addAutoReplyRule from '../services/addAutoReplyRule';

export default {
  namespace: 'addAutoReplyRule',

  state: {
    autoReplyRuleFormData: {
      name: '',
      type: 'TEXT',
      replyTypeForm: {
        TEXT: {
          content: '',
        },
        MINIPROGRAMPAGE: {
          title: '',
          miniProgramAppId: '',
          miniProgramPagePath: '',
          thumbMediaFilePath: '',
        },
        IMAGE: {
          mediaFilePath: '',
        },
        VIDEO: {
          title: '',
          description: '',
          mediaFilePath: '',
          thumbMediaFilePath: '',
        },
      },
    },
    replyTypeFileData: {
      MINIPROGRAMPAGE: {
        imgUrl: '',
      },
      IMAGE: {
        imgUrl: '',
      },
      VIDEO: {
        imgUrl: '',
        videoUrl: '',
      },
    },
  },

  effects: {
    //模板列表
    *getMiniProgramAccountList(
      { payload: { values }, callback },
      { call, put },
    ) {
      const response = yield call(
        addAutoReplyRule.getMiniProgramAccountList,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          miniProgramAccountList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //保存数据
    *updateAutoReplyRuleFormData({ payload: { values } }, { put, select }) {
      const { currentType, type, name, ...restParam } = values;
      const replyTypeFormItem = { [type]: { ...restParam } };
      const { replyTypeForm: preReplyTypeForm } = yield select(
        (state) => state.addAutoReplyRule.autoReplyRuleFormData,
      );
      const updateReplyRuleFormData = {
        name,
        type: currentType,
        replyTypeForm: { ...preReplyTypeForm, ...replyTypeFormItem },
      };
      yield put({
        type: 'save',
        payload: {
          autoReplyRuleFormData: updateReplyRuleFormData,
        },
      });
    },
    //保存上传的图片的相关信息
    *updateAutoReplyFileData({ payload: { values } }, { put, select }) {
      const { type, ...restParam } = values;
      const replyTypeFileData = yield select(
        (state) => state.addAutoReplyRule.replyTypeFileData,
      );
      const videoItem = replyTypeFileData.VIDEO;
      let updateReplyTypeFileData = {};
      if (type !== 'VIDEO') {
        updateReplyTypeFileData = {
          ...replyTypeFileData,
          [type]: { ...restParam },
        };
      } else {
        updateReplyTypeFileData = {
          ...replyTypeFileData,
          [type]: { ...videoItem, ...restParam },
        };
      }

      yield put({
        type: 'save',
        payload: {
          replyTypeFileData: updateReplyTypeFileData,
        },
      });
    },
    //新增自动回复规则
    *addReplyRule({ payload: { values }, callback }, { call }) {
      const response = yield call(addAutoReplyRule.addReplyRule, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //更新自动回复
    *updateReplyRule({ payload: { values }, callback }, { call }) {
      const response = yield call(addAutoReplyRule.updateReplyRule, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //查询单个自动回复规则
    *getReplyRuleDetail({ payload: { values }, callback }, { call, put }) {
      const response = yield call(addAutoReplyRule.getReplyRuleDetail, values);
      const {
        type,
        name,
        content,
        miniProgramAppId,
        miniProgramPagePath,
        thumbMediaFilePath,
        title,
        mediaFilePath,
        description,
      } = response?.data;
      let updateItem;
      switch (type) {
        case 'TEXT':
          updateItem = { content };
          break;
        case 'MINIPROGRAMPAGE':
          updateItem = {
            miniProgramAppId,
            miniProgramPagePath,
            thumbMediaFilePath,
            title,
          };
          break;
        case 'IMAGE':
          updateItem = {
            mediaFilePath,
          };
          break;
        case 'VIDEO':
          updateItem = {
            thumbMediaFilePath,
            mediaFilePath,
            title,
            description,
          };
          break;
        default:
          updateItem = {};
      }
      yield put({
        type: 'updateAutoReplyRuleFormData',
        payload: {
          values: {
            currentType: type,
            type,
            name,
            ...updateItem,
          },
        },
      });
      if (type === 'IMAGE') {
        yield put({
          type: 'updateAutoReplyFileData',
          payload: {
            values: {
              type,
              imgUrl: mediaFilePath,
            },
          },
        });
      } else {
        yield put({
          type: 'updateAutoReplyFileData',
          payload: {
            values: {
              type,
              imgUrl: thumbMediaFilePath,
              videoUrl: mediaFilePath,
            },
          },
        });
      }

      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //同步关注后自动回复规则
    *synSubscribeReply({ callback }, { call, select }) {
      const autoReplyData = yield select(
        (state) => state.autoReply.autoReplyData,
      );
      const autoReplyList = yield select(
        (state) => state.autoReply.autoReplyList,
      );
      const values = { ...autoReplyData, rules: autoReplyList };
      const response = yield call(addAutoReplyRule.synSubscribeReply, values);
      // yield put({
      //   type: 'save',
      //   payload: {
      //     wechatTemplateMessageList: response?.data,
      //   },
      // });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    *clearAutoReplyRuleFormData({ payload: { values } }, { put }) {
      yield put({
        type: 'save',
        payload: {
          autoReplyRuleFormData: {
            ...values,
          },
          replyTypeFileData: {
            MINIPROGRAMPAGE: {
              imgUrl: '',
            },
            IMAGE: {
              imgUrl: '',
            },
            VIDEO: {
              imgUrl: '',
              videoUrl: '',
            },
          },
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (
          [
            '/system/autoReply/rule_add',
            '/system/autoReply/rule_edit',
            '/system/autoReply/rule_detail',
          ].includes(props.pathname)
        ) {
          dispatch({
            type: 'clearAutoReplyRuleFormData',
            payload: {
              values: {
                name: '',
                type: 'TEXT',
                replyTypeForm: {
                  TEXT: {
                    content: '',
                  },
                  MINIPROGRAMPAGE: {
                    title: '',
                    miniProgramAppId: '',
                    miniProgramPagePath: '',
                    thumbMediaFilePath: '',
                  },
                  IMAGE: {
                    mediaFilePath: '',
                  },
                  VIDEO: {
                    title: '',
                    description: '',
                    mediaFilePath: '',
                    thumbMediaFilePath: '',
                  },
                },
              },
            },
          });
        }
      });
    },
  },
};
